import Image from "next/image";
import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { isJSXElement } from "@utils/common";

type StarFill = "half" | "full";

interface ComparisonPageTestimonialProps {
    mainTitle?: string | JSX.Element;
    quotationText: string | JSX.Element;
    question: string | JSX.Element;
    description: string | JSX.Element;
    founderName: string;
    companyName: string;
    starFill?: StarFill[];
    button?: boolean;
    selectedCard?: number;
    setSelectedCard?: (value: string) => void;
}

const ComparisonPageTestimonial: React.FC<ComparisonPageTestimonialProps> = ({
    mainTitle,
    quotationText,
    question,
    description,
    founderName,
    companyName,
    starFill,
    button,
    selectedCard,
    setSelectedCard,
}) => {
    return (
        <div className="w-fit mx-auto relative">
            {isJSXElement(mainTitle) ? (
                mainTitle
            ) : (
                <h6 className="text-center mx-auto text-2xl md:text-5xl">
                    <span className="relative w-fit inline-block" style={{ zIndex: 2 }}>
                        {mainTitle}
                        <svg
                            className="absolute right-0"
                            style={{ zIndex: -1, bottom: "-25px", right: "0px" }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="100%"
                            height="39"
                            viewBox="0 0 290 39"
                            fill="none"
                        >
                            <path d="M1.13689 12.9043L288.611 4.06572" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                            <path d="M119.139 21.865L236.602 15.142L288.777 14.2123" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <svg style={{ top: "0px", right: "-29px", position: "absolute" }} xmlns="http://www.w3.org/2000/svg" width="27" height="22" viewBox="0 0 27 22" fill="none">
                            <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                            <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                            <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </span>
                </h6>
            )}
            <div className="lg:mt-14 mt-10 relative">
                <div className="wati-testimonial-blk text-left m-auto lg:p-20" style={{ background: "linear-gradient(115deg, #EBF0FF -0.01%, #FFF 39.18%)" }}>
                    <a href="https://www.g2.com/products/gallabox/reviews/gallabox-review-7643564" rel="noreferrer" target="_blank">
                        <img
                            loading="lazy"
                            src="https://assets.gallabox.com/gb-home/new-wati/orange-logo.svg"
                            alt="G2 logo"
                            style={{ position: "absolute", right: "10px", top: "10px" }}
                            className="hidden md:block"
                        />
                    </a>
                    <div>
                        {starFill && (
                            <div className="testi-star flex justify-center md:justify-start">
                                {starFill.map((star, i) => (
                                    <div key={i} className="flex items-center justify-center" style={{ width: "38px", height: "35px" }}>
                                        <Image
                                            className="flex-shrink-0"
                                            height={38}
                                            width={star === "full" ? 35 : 38}
                                            src={`https://assets.gallabox.com/gb-home/new-wati/${star}-star.svg`}
                                            alt={`${star === "full" ? "full star" : `${star} filled star`}`}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                        {isJSXElement(quotationText) ? quotationText : <h2 className="text-2xl font-bold my-5 px-10 md:px-0 md:mt-2.5 md:mb-0">{quotationText}</h2>}
                        {isJSXElement(question) ? question : <p className="text-gray-600 text-base md:text-lg font-medium px-10 md:px-0 my-2.5">{question}</p>}
                        {isJSXElement(description) ? description : <p className="text-gray-500 text-base md:text-lg font-normal px-9 md:px-0">{description}</p>}
                        <div className="text-gray-700 mt-5 md:mt-6 lg:px-0 px-9">
                            <p className="font-bold text-2xl">{founderName}</p>
                            <span className="font-normal text-lg">{companyName}</span>
                        </div>
                        {button && setSelectedCard && (
                            <div className="flex justify-center mt-10">
                                <button onClick={() => setSelectedCard("minus")} className="mr-2">
                                    <FaChevronLeft />
                                </button>
                                <span className={`w-3 h-3 rounded-full ${selectedCard === 0 ? "bg-blue-600" : "bg-blue-300"} mr-2`}></span>
                                <span className={`w-3 h-3 rounded-full ${selectedCard === 1 ? "bg-blue-600" : "bg-blue-300"}`}></span>
                                <button onClick={() => setSelectedCard("plus")} className="ml-2">
                                    <FaChevronRight />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComparisonPageTestimonial;
